module.exports = __webpack_public_path__ + "img/none_data.1c27e03c.png";